var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "y-bk-fff y-mt-10 y-pd-20 staff-content" },
    [
      _c(
        "div",
        { staticClass: "y-mt-15 y-mb-15" },
        [
          _c("span", { staticClass: "y-fc-F56C6C" }, [_vm._v("*")]),
          _c("span", { staticClass: "y-fs-14 y-fc-333 y-fw-500" }, [
            _vm._v("角色名称"),
          ]),
          _c("el-input", {
            staticClass: "y-w-180",
            attrs: {
              placeholder: "请输入角色名称",
              size: "mini",
              disabled: _vm.readonly,
            },
            model: {
              value: _vm.roleForm.roleName,
              callback: function ($$v) {
                _vm.$set(_vm.roleForm, "roleName", $$v)
              },
              expression: "roleForm.roleName",
            },
          }),
          _vm.readonly
            ? _c(
                "span",
                {
                  staticClass: "y-fc-4C84FF y-c-p y-fs-12 y-ml-5",
                  on: { click: _vm.goCreate },
                },
                [_vm._v("角色权限不满足需求？去创建新角色")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "y-pl-10 y-mb-15" },
        [
          _c("el-checkbox", {
            attrs: {
              disabled: _vm.readonly,
              indeterminate: _vm.halfCheckedAllAuth,
            },
            on: { change: _vm.chooseAllAuth },
            model: {
              value: _vm.checkedAllAuth,
              callback: function ($$v) {
                _vm.checkedAllAuth = $$v
              },
              expression: "checkedAllAuth",
            },
          }),
          _c("span", { staticClass: "y-fc-333 y-fs-14 y-fw-500" }, [
            _vm._v("分配所有客户编码/店铺权限和菜单权限"),
          ]),
        ],
        1
      ),
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { name: "1" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "coll-title" }, [
                  _c("span", { staticClass: "y-fc-F56C6C" }, [_vm._v("*")]),
                  _c("span", { staticClass: "maint" }, [
                    _vm._v("客户编码/店铺权限"),
                  ]),
                  _c("span", { staticClass: "maini" }, [
                    _vm._v("（该角色的员工不用绑定，直接可以使用）"),
                  ]),
                ]),
              ]),
              _vm.roleInfoListGet
                ? _c("shopAuth", {
                    ref: "shopAuth",
                    attrs: {
                      isCreate: _vm.isCreate,
                      roleForm: _vm.roleForm,
                      readonly: _vm.readonly,
                    },
                    on: { getKCodeChooseStatus: _vm.getKCodeChooseStatus },
                  })
                : _vm._e(),
            ],
            2
          ),
          _c(
            "el-collapse-item",
            { attrs: { name: "2" } },
            [
              _c("template", { slot: "title" }, [
                _c("div", { staticClass: "coll-title" }, [
                  _c("span", { staticClass: "y-fc-F56C6C" }, [_vm._v("*")]),
                  _c("span", { staticClass: "maint" }, [_vm._v("菜单权限")]),
                  _c("span", { staticClass: "maini" }, [
                    _vm._v("（该角色可查看以下菜单）"),
                  ]),
                ]),
              ]),
              _c("authTable", {
                ref: "authTable",
                attrs: {
                  isAdministrators: _vm.isAdministrators,
                  roleName: _vm.$route.params.editName,
                  roleId: _vm.$route.params.editId,
                  sourceData: _vm.sourceData,
                  readonly: _vm.readonly,
                },
                on: { getMenuAuthStatus: _vm.getMenuAuthStatus },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "staff-footer" },
        [
          _vm.$route.name != "SeeRole"
            ? [
                _c(
                  "el-button",
                  { staticClass: "y-w-100", on: { click: _vm.cancel } },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "y-w-100",
                    attrs: { type: "primary" },
                    on: { click: _vm.confirm },
                  },
                  [_vm._v("保存")]
                ),
              ]
            : _vm._e(),
          _vm.$route.name == "SeeRole"
            ? [
                _c(
                  "el-button",
                  {
                    staticClass: "y-w-100",
                    attrs: { type: "primary" },
                    on: { click: _vm.close },
                  },
                  [_vm._v("关闭")]
                ),
              ]
            : _vm._e(),
          _vm.$route.params.editId &&
          _vm.$route.params.editName != "普通员工" &&
          _vm.$route.params.editName != "管理员"
            ? _c(
                "el-button",
                {
                  staticClass: "y-w-100 delete-btn",
                  on: { click: _vm.delRole },
                },
                [_vm._v("删除角色")]
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }